<div class=" rounded heading" [class]="theme.myIconColor">
        {{heading}}
</div> 
